var map = {
	"./ion-action-sheet.entry.js": [
		407,
		2788
	],
	"./ion-alert.entry.js": [
		3708,
		3708
	],
	"./ion-app_8.entry.js": [
		9438,
		9438
	],
	"./ion-avatar_3.entry.js": [
		8183,
		8183
	],
	"./ion-back-button.entry.js": [
		2383,
		4764
	],
	"./ion-backdrop.entry.js": [
		4506,
		4506
	],
	"./ion-button_2.entry.js": [
		9105,
		9105
	],
	"./ion-card_5.entry.js": [
		9586,
		9586
	],
	"./ion-checkbox.entry.js": [
		7393,
		7393
	],
	"./ion-chip.entry.js": [
		8466,
		8466
	],
	"./ion-col_3.entry.js": [
		3430,
		3430
	],
	"./ion-datetime_3.entry.js": [
		7651,
		7651
	],
	"./ion-fab_3.entry.js": [
		4537,
		4537
	],
	"./ion-img.entry.js": [
		3861,
		3861
	],
	"./ion-infinite-scroll_2.entry.js": [
		1985,
		1985
	],
	"./ion-input.entry.js": [
		4646,
		4646
	],
	"./ion-item-option_3.entry.js": [
		5795,
		5795
	],
	"./ion-item_8.entry.js": [
		7740,
		7740
	],
	"./ion-loading.entry.js": [
		7658,
		7658
	],
	"./ion-menu_3.entry.js": [
		2133,
		2133
	],
	"./ion-modal.entry.js": [
		943,
		943
	],
	"./ion-nav_2.entry.js": [
		850,
		850
	],
	"./ion-popover.entry.js": [
		9795,
		9795
	],
	"./ion-progress-bar.entry.js": [
		6719,
		6719
	],
	"./ion-radio_2.entry.js": [
		8924,
		8924
	],
	"./ion-range.entry.js": [
		2443,
		2443
	],
	"./ion-refresher_2.entry.js": [
		923,
		923
	],
	"./ion-reorder_2.entry.js": [
		6928,
		6928
	],
	"./ion-ripple-effect.entry.js": [
		9902,
		9902
	],
	"./ion-route_4.entry.js": [
		6016,
		6016
	],
	"./ion-searchbar.entry.js": [
		2727,
		2727
	],
	"./ion-segment_2.entry.js": [
		1590,
		1590
	],
	"./ion-select_3.entry.js": [
		4994,
		4994
	],
	"./ion-slide_2.entry.js": [
		2886,
		2886
	],
	"./ion-spinner.entry.js": [
		4423,
		4423
	],
	"./ion-split-pane.entry.js": [
		853,
		853
	],
	"./ion-tab-bar_2.entry.js": [
		2740,
		2740
	],
	"./ion-tab_2.entry.js": [
		2980,
		2980
	],
	"./ion-text.entry.js": [
		6268,
		3887
	],
	"./ion-textarea.entry.js": [
		1206,
		1206
	],
	"./ion-toast.entry.js": [
		3161,
		3161
	],
	"./ion-toggle.entry.js": [
		4928,
		4928
	],
	"./ion-virtual-scroll.entry.js": [
		2051,
		2051
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3111;
module.exports = webpackAsyncContext;